import { observer } from 'mobx-react';
import OneOfferingType from './OneOfferingType';
import TwoOfferingTypes from './TwoOfferingTypes';
import ThreeOfferingTypes from './ThreeOfferingTypes';
import FourOfferingTypes from './FourOfferingTypes';
import { emptyFragment } from '../../../../../../../EmptyFragment';

interface Props {
  utilized: number;
  total: number;
}

function Counter({ utilized, total }: Props) {
  switch (total) {
    case 1:
      return <OneOfferingType utilized={utilized} />;
    case 2:
      return <TwoOfferingTypes utilized={utilized} />;
    case 3:
      return <ThreeOfferingTypes utilized={utilized} />;
    case 4:
      return <FourOfferingTypes utilized={utilized} />;
    default:
      return emptyFragment();
  }
}

export default observer(Counter);
